import { useLazyQuery } from '@apollo/client';
import React from 'react';
import { PublishedDatasourceLineageLabelsQuery } from '../../../../../../../gen-src/queries';
import { FeatureFlagsContext } from '../../../featureFlags/FeatureFlagsContext';
import { useContextWithOverride } from '../HookContext';
import { UseLabelsResult, UseLabelsResultWithExecuteFunction } from '../useRenderLabelsTypes';
import { GetContentLineageLabelsLazyQueryParams, convertLabelsFragmentIntoRenderProps } from './lazyQueryHelper';

export function usePublishedDatasourceLineageLabelsLazyQuery({ item, controls, includeParented, includeUpstream, document, contextOverrides }: GetContentLineageLabelsLazyQueryParams): UseLabelsResultWithExecuteFunction {
  const { customSensitivityLabelsEnabled } = useContextWithOverride(FeatureFlagsContext, contextOverrides?.featureFlags);

  const [fire, { loading, error, data }] = useLazyQuery<PublishedDatasourceLineageLabelsQuery>(document);
  const invoke = React.useCallback(() => { void fire({ variables: { luid: item.contentLuid ?? null, id: item.contentId ?? null, customSensitivityLabelsEnabled } }) }, [fire, item, customSensitivityLabelsEnabled]);

  const upstreamLabels = data?.items[0] ? data?.items[0].upstreamLabels : undefined;
  const inheritedByCandidates = data?.items[0] ? data.items[0].fields : undefined;
  const result: UseLabelsResult = { loading, error, ...convertLabelsFragmentIntoRenderProps({ upstreamLabels, item, controls, includeParented, includeUpstream, inheritedByCandidates }) };
  return [invoke, result]
}
